import { dspxDiffDays } from '../../../helpers/dspx-utils';

const activeStatuses = [1, 2];

export const generateRequestsCounts = (request, data) => {
  const diff = request.doneDate
    ? dspxDiffDays(request.doneDate, request.executeTime)
    : dspxDiffDays(0, request.executeTime);

  const hasActiveStatus = activeStatuses.includes(request.statusId);

  if (request.doneDate || hasActiveStatus) {
    const lifetime = dspxDiffDays(
      hasActiveStatus ? 0 : request.doneDate,
      request.createDateTime
    );

    data.totalRequestLifetime += lifetime;
    data.done += 1;
  }

  if (request.statusId === 1) {
    data.active += 1;
  }

  if (request.isImmediate) {
    data.immediate += 1;
  }

  if (diff > 0) {
    data.expired += 1;
  }

  if (request.isRetry) {
    data.retry += 1;
  }

  if (request.isChargeable) {
    data.chargeable += 1;
  }
};
